import * as iotServicesSdk from 'iot-services-sdk';

const state = {    
    apiKeys:[],
    apikeyManager:null
}

const getters = {
        
}

const actions = {
    init({rootState, commit}){
        const httpInfo = rootState.metadata.backendApi.http.prod;
        
        const baseUrl = "https://" + httpInfo.host + "/" + httpInfo.basePath;
        const service = httpInfo.service;
        const region = httpInfo.region;

        const atrApikeyManager = new iotServicesSdk.apikey.assettracking.ATRApikeyManager(
            new URL(baseUrl), 
            new iotServicesSdk.shared.auth.sigv4.SigV4Authorizer(service, region),
            region
        );
        commit('init', atrApikeyManager)
    },

    deinit({commit}){
        return new Promise(
            (resolve)=>{
                commit('clearApiKeys')
                resolve()
            }
        )
    },

    fetchApiKeys:function({rootState,commit}){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Fetching API keys',{root:true})

                state.apikeyManager.getApikeys(rootState.authentication.credentials)
                // rootState.serviceModule.deviceManager.ListApiKeys()
                    .then((apiKeys)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','API keys fetched',{root:true})
                        commit('updateApiKeys',apiKeys)
                        resolve()                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Fetching API keys failed',{root:true})
                        reject(err)                
                    })
            }
        ) 
    },

    createApiKey({commit,rootState},apiKey){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Creating API key',{root:true})

                const newApikey =  new iotServicesSdk.apikey.models.NewApikey(apiKey.name)
                state.apikeyManager.createApikey(newApikey, rootState.authentication.credentials)
                // rootState.serviceModule.deviceManager.CreateApiKey(apiKey)
                    .then((data)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Creating success',{root:true})
                        resolve(data)                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Creating failed'+((err)?': '+err:''),{root:true})
                        reject(err)                
                    })
            }
        )        
    },

    deleteApiKey({commit,rootState},apiKey){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Deleting API key',{root:true})
                state.apikeyManager.deleteApikey(apiKey.id, rootState.authentication.credentials)
                // rootState.serviceModule.deviceManager.DeleteApiKey(apiKey)
                    .then((data)=>{           
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','Deleting success',{root:true})

                        commit('clearApiKeys',apiKey)
                        resolve(data)                        
                    })
                    .catch((err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','Deleting failed'+((err)?': '+err:''),{root:true})
                        reject(err)                
                    })
            }
        )        
    },

}

const mutations = {
    init(state, apikeyManager){
        state.apikeyManager = apikeyManager;
    },

    clearApiKeys(state, apiKey){
        if(apiKey)
            state.apiKeys = state
                            .apiKeys
                            .filter(
                                (storedApikey) => 
                                    !(apiKey.value==storedApikey.value)
                            )
        else
            state.devices.splice(0)
    },


    updateApiKeys(state,apiKeys){
        state.apiKeys = apiKeys
    }
}
  

export default{
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced:true
}